/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import Loader from '../loaders/loader'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import {message} from 'antd'
import Select from 'react-select'
import {ExcelExport, ExcelExportColumn, grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchProduct from '../BaseComponent/SearchProduct'
import SearchableCombo from '../BaseComponent/searchableCombo'
import DeliveryPackComponent from '../BaseComponent/deliveryPackComponent'
import DeliveryPackPrint from '../BaseComponent/deliveryPackPrint'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import queryParams from '../BaseComponent/QueryParams'
import {withRouter} from 'react-router-dom'
import AutoComplete from '../BaseComponent/autocomplete'
class Baskets extends React.Component {
  constructor(props) {
    sessionStorage.setItem('statusDefault', true)
    super(props)
    this.state = {
      loading: false,
      baskets: [],
      lengthbaskets: 0,
      modal: false,
      urlSign: '',
      Drivers: [],
      tasvie: '',
      state: '',
      printInfo: [],
      shift: '',
      finalShift: '',
      driverSelect: '',
      finalDriverSelect: '',
      multiUnit: [],
      unitArr: [],
      multiProvider: [],
      providerArr: [],
      providers: [],
      multiProduct: [],
      productArr: [],
      products: [],
      lengthProducts: 0,
      search: '',
      current: 1,
      selectedStockProductIds: [],
      arrayOfStocks: [],
      finalStocks: [],
      aggregation: {},
      fromDate: '',
      toDate: '',
      timesInterval: [],
      exportExcel: [],
      excelReport: [],
      buttonClicked: false,
      defaultValueDate: true,
      fromRegDate: '',
      toRegDate: '',
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'registerDate_desc',
      showLinkIndividual: false,
      tablePageNumber: 1,
      tablePageSize: 1,
      providerId: ''
    }
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    let createQueryFilter = filter
    delete createQueryFilter.export
    this.props.history.push(`?${queryParams(createQueryFilter)}`)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          if (!exportStatus) {
            this.state.loading = false

            let res = response.data.object.result

            let pageNumber = sessionStorage.getItem('pageNumber')

            let dropDownVal = document.getElementById('dropDownVal').value

            for (let i = 0; i < res.length; i++) {
              res[i]['id'] = (pageNumber - 1) * dropDownVal + i + 1
            }
            $('.showBaseTable,.print').fadeIn()

            sessionStorage.setItem('countAll', response.data.object.countAll)
            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              baskets: response.data.object.result,
              countAll: response.data.object.countAll,
              finalDriverSelect: this.state.driverText,
              finalShift: this.state.shift,
              buttonClicked: true,
              loading: false,
              showLinkIndividual: true
            })
          } else {
            this.setState({
              loading: false,
              printInfo: response.data.object.result
              // ,
              // aggregation:response.data.object.aggregation
            })
            setTimeout(() => {
              window.print()
            }, 2000)
          }
        } else {
          message.error(response.data.description)
          this.setState({
            loading: false,
            baskets: []
          })
          $('.showBaseTable,.print').fadeOut()
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          baskets: []
        })
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate
    let {providerArr, unitArr, finalStocks} = this.state
    let planTimeType = document.getElementById('planTimeType').value
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value.trim()
    let userCode = document.getElementById('userCode').value.trim()
    let nationalId = document.getElementById('nationalId').value.trim()
    let mobile = document.getElementById('mobile').value
    let recipientName = document.getElementById('recipientName').value.trim()
    let paid = document.getElementById('paid').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    let payableAmountMin = this.convertDigit(document.getElementById('payableAmountMin').value.trim())
    let payableAmountMax = this.convertDigit(document.getElementById('payableAmountMax').value.trim())
    let cashMin = this.convertDigit(document.getElementById('cashMin').value.trim())
    let cashMax = this.convertDigit(document.getElementById('cashMax').value.trim())
    let lastState = document.getElementById('lastState').value
    let paperInvoice = document.getElementById('paperInvoice').value
    let providerId = this.state.providerId
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (providerId) {
      filter.providerIds = providerId
    }
    if (finalStocks.length !== 0) {
      filter.stockProductIds = finalStocks.join(',')
    }
    if (unitArr.length !== 0) {
      filter.productUnitIds = unitArr.join(',')
    }
    if (payableAmountMin !== '') {
      filter.payableAmountMin = payableAmountMin
    }
    if (minDate !== '') {
      filter.planDateMin = minDate
    }
    if (maxDate !== '') {
      filter.planDateMax = maxDate
    }
    if (fromRegDate !== '') {
      filter.registerDateMin = fromRegDate
    }
    if (toRegDate !== '') {
      filter.registerDateMax = toRegDate
    }
    if (payOnDelivery !== '') {
      filter.payOnDelivery = payOnDelivery
    }
    if (payableAmountMax !== '') {
      filter.payableAmountMax = payableAmountMax
    }
    if (cashMin !== '') {
      filter.cashMin = cashMin
    }
    if (cashMax !== '') {
      filter.cashMax = cashMax
    }
    if (buyerName !== '') {
      filter.buyerName = buyerName
    }
    if (lastState !== '') {
      filter.lastState = lastState
    }
    if (paperInvoice !== '') {
      if (paperInvoice == 1) {
        filter.paperInvoice = true
      } else {
        filter.paperInvoice = false
      }
    }
    if (planTimeType !== '') {
      let find = this.state.timesInterval.find((item) => +item.timeIntervalId === +planTimeType)
      if (find) {
        filter.timeStart = find.timeStart
        filter.timeEnd = find.timeEnd
      }
      // filter.timeIntervalId = planTimeType
    }
    if (invoiceNum !== '') {
      filter.invoiceNum = invoiceNum
    }
    if (invoiceId !== '') {
      filter.invoiceId = invoiceId
    }
    if (driverId !== '') {
      filter.driverId = driverId
    }
    if (canceled !== '') {
      filter.canceled = canceled
    }
    if (confirmed !== '') {
      filter.confirmed = confirmed
    }
    if (paid !== '') {
      filter.paid = paid
    }
    if (recipientName !== '') {
      filter.recipientName = recipientName
    }
    if (mobile !== '') {
      filter.mobile = mobile
    }
    if (nationalId !== '') {
      filter.userNationalId = nationalId
    }
    if (userCode !== '') {
      filter.userCode = userCode
    }
    return filter
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  handleChangeUnit = (multiUnit) => {
    var unitArr = []
    this.setState({multiUnit})
    // alert(multiUnit.length)
    if (multiUnit.length == '0') {
      this.setState({
        unitArr: []
      })
    } else {
      for (let prop of multiUnit) {
        unitArr.push(prop.id)
        this.setState({
          unitArr: unitArr
        })
      }
    }
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  loadDeliveryPack = (userCode, invoiceId, deliveryPackId, invoiceNum) => {
    this.setState({
      loading: true
    })
    let filter = {
      userCode,
      invoiceId,
      deliveryPackId,
      invoiceNum,
      export: false,
      pageSize: 10,
      pageNumber: 1,
      sortBy: 'planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc'
    }

    let createQueryFilter = filter
    delete createQueryFilter.export
    this.props.history.push(`?${queryParams(createQueryFilter)}`)

    http
      .get(REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            baskets: response.data.object.result,
            showLinkIndividual: true,
            lengthbaskets: response.data.object.countAll,
            finalDriverSelect: this.state.driverText,
            finalShift: this.state.shift,
            // aggregation:response.data.object.aggregation
            // ,
            buttonClicked: true,
            countAll: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            baskets: [],
            loading: false
          })
          $('.showBaseTable,.print').fadeOut()
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          baskets: [],
          loading: false
        })
        // alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    var userCode = urlParams.get('userCode') === null ? '' : urlParams.get('userCode')
    var invoiceId = urlParams.get('invoiceId') === null ? '' : urlParams.get('invoiceId')
    var invoiceNum = urlParams.get('invoiceNum') === null ? '' : urlParams.get('invoiceNum')
    var deliveryPackId = urlParams.get('deliveryPackId') === null ? '' : urlParams.get('deliveryPackId')

    if (!(userCode === '' && invoiceId === '' && deliveryPackId === '' && invoiceNum === '')) {
      this.setState({
        userCode,
        invoiceId,
        invoiceNum
      })
      sessionStorage.setItem('pageNumber', '1')
      sessionStorage.setItem('dropDownVal', '10')
      localStorage.setItem(
        'deliveryPackParams',
        `deliveryPackId=${deliveryPackId}&userCode=${userCode}&invoiceId=${invoiceId}&invoiceNum=${invoiceNum}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`
      )
      this.loadDeliveryPack(userCode, invoiceId, deliveryPackId, invoiceNum)
      this.setState({
        defaultValueDate: false
      })
    } else {
      sessionStorage.removeItem('params')
    }

    http.get(`public/base/type/timeIntervals`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          timesInterval: response.data.object
        })
      }
    })

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_UNIT}`, {}).then((response) => {
      if (response.data.error == null) {
        var unit = response.data.object
        for (let i = 0; i < unit.length; i++) {
          unit[i]['value'] = unit[i].id
          unit[i]['label'] = unit[i].title
        }

        this.setState({
          unit: response.data.object
        })
      } else {
        this.setState({
          unit: []
        })
      }
    })

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var provider = response.data.object
          for (let i = 0; i < provider.length; i++) {
            provider[i]['value'] = provider[i].providerId
            provider[i]['label'] = provider[i].providerId + ' - ' + provider[i].title
          }

          this.setState({
            providers: response.data.object
          })
        } else {
          this.setState({
            providers: []
          })
        }
      })
      .catch(() => {})

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  onResultFetched(data) {
    this.setState({
      baskets: data
    })
  }

  changeDropDown(data) {
    this.setState({
      baskets: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value

    this.setState({
      tasvie: value == '' ? '' : Number(value)
    })
  }

  changeState(e) {
    let target = e.target
    let value = target.value

    this.setState({
      state: value
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeFromRegDate = (fromRegDate) => {
    this.setState({
      fromRegDate
    })
  }

  handleChangeToRegDate = (toRegDate) => {
    this.setState({
      toRegDate
    })
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  filter() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let fromRegDate = this.state.fromRegDate
    let toRegDate = this.state.toRegDate

    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تحویل ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تحویل انتها صحیح نیست')
    } else if ((fromRegDate != '' || fromRegDate == null) && isNaN(fromRegDate)) {
      message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    } else if ((toRegDate != '' || toRegDate == null) && isNaN(toRegDate)) {
      message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    } else {
      localStorage.setItem('deliveryPackParams', queryParams(this.createFilter(true)))
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
        loading: true,
        pageNumber: 1
      })
      setTimeout(() => {
        this.getReport(false)
      }, 500)
    }
  }

  changeShift(e) {
    let target = e.target

    this.setState({
      shift: target.options[target.selectedIndex].text
    })
  }

  submitForm(e) {
    e.preventDefault()
  }

  exportExcel = () => {
    let params = queryParams(this.createFilter(true))
    this.setState({loading: true})
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}?${params}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        this.setState({loading: false})

        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            loading: false,
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['getDeliveryType'] = this.getDeliveryType(excelReport[i])
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['canceled']) {
              excelReport[i].invoice['canceled'] = 'کنسل شده'
            } else {
              excelReport[i].invoice['canceled'] = 'کنسل نشده'
            }

            if (excelReport[i].invoice['confirmed']) {
              excelReport[i].invoice['confirmed'] = 'تایید شده'
            } else {
              excelReport[i].invoice['confirmed'] = 'تایید نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }

            if (excelReport[i].driver == null) {
              excelReport[i].driver = ''
            } else {
              excelReport[i].driver = excelReport[i].driver['name']
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch(() => {
        this.setState({loading: false})
      })
  }

  newExcel = () => {
    this.setState({
      loading: true
    })

    let params = queryParams(this.createFilter(true))

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}?${params}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            loading: false,
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)
            excelReport[i]['driverName'] = excelReport[i]['driver'] === null ? '' : excelReport[i].driver['personId']
            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['canceled']) {
              excelReport[i].invoice['canceled'] = 'کنسل شده'
            } else {
              excelReport[i].invoice['canceled'] = 'کنسل نشده'
            }

            if (excelReport[i].invoice['confirmed']) {
              excelReport[i].invoice['confirmed'] = 'تایید شده'
            } else {
              excelReport[i].invoice['confirmed'] = 'تایید نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }

            if (excelReport[i].driver === null) {
              excelReport[i].driver = ''
            } else {
              excelReport[i].driver = excelReport[i].driver['personId']
            }
          }
          this.newExport.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch(() => {})
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  getDeliveryType = (items) => {
    if (items.hasSign) {
      return 'امضا'
      // return ''
    } else {
      if (items.deliveryCode === null) {
        return ' - '
      } else if (items.deliveryCode === true) {
        return ' کد مشتری'
      } else if (items.deliveryCode === false) {
        return ' کد پشتیبان'
      }
    }
  }

  render() {
    let {loading} = this.state

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        {/*{loading ? <Loader></Loader> :null}*/}
        <DeliveryPackPrint
          printInfo={this.state.printInfo}
          aggregation={this.state.aggregation}
          rightSectionPrint={
            'تاریخ تحویل از : ' +
            (this.state.toPrintDate === undefined ? '' : this.state.toPrintDate) +
            ' تا ' +
            (this.state.fromPrintDate === undefined ? '' : this.state.fromPrintDate)
          }
          centerSection={''}
        />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش پارت تحویل.xls"
          >
            <ExcelExportColumn
              key={'planDate'}
              field={'planDate'}
              title={'تاریخ تحویل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'bazeTahvil'}
              field={'bazeTahvil'}
              title={'بازه تحویل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'invoiceId'}
              field={'invoice.invoiceId'}
              title={'شناسه فاکتور'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'invoiceNum'}
              field={'invoice.invoiceNum'}
              title={'شماره فاکتور'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'buyerName'}
              field={'invoice.buyerName'}
              title={'نام خریدار'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'userCode'}
              field={'customer.userCode'}
              title={'کد مشتری'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'nationalId'}
              field={'customer.nationalId'}
              title={'کد ملی'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'recipientName'}
              field={'invoice.recipientName'}
              title={'تحویل گیرنده'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'mobile'}
              field={'invoice.mobile'}
              title={'موبایل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'paid'}
              field={'invoice.paid'}
              title={'وضعیت پرداخت'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'confirmed'}
              field={'invoice.confirmed'}
              title={'وضعیت تایید'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'canceled'}
              field={'invoice.canceled'}
              title={'وضعیت کنسل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'payOnDelivery'}
              field={'invoice.payOnDelivery'}
              title={'پرداخت در محل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'driver'}
              field={'driver'}
              title={'رساننده'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'payableAmount'}
              field={'totalInfo.payableAmount'}
              title={'قابل پرداخت'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'cash'}
              field={'payment.cash'}
              title={'پرداخت نقدی'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'card'}
              field={'payment.card'}
              title={'پرداخت کارتخوان'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'prePaid'}
              field={'payment.prePaid'}
              title={'پرداخت از قبل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'getDeliveryType'}
              field={'getDeliveryType'}
              title={'نوع تحویل'}
              width="100px"
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this.newExport = exporter
            }}
            fileName="OP Time Export.xlsx"
          >
            <ExcelExportColumn
              key={'deliveryPackId'}
              field={'deliveryPackId'}
              title={'Id'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'district'}
              field={'district'}
              title={'District'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'address'}
              field={'invoice.address'}
              title={'Address'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'latitude'}
              field={'invoice.latitude'}
              title={'Latitude'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'longitude'}
              field={'invoice.longitude'}
              title={'Longitude'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'weight'}
              field={'weight'}
              title={'Weight'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'volume'}
              field={'volume'}
              title={'Volume'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'bazeTahvil'}
              field={'bazeTahvil'}
              title={'CustomerTimeWindow'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'serviceTime'}
              field={'serviceTime'}
              title={'ServiceTime'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'driver'}
              field={'driverName'}
              title={'DriverName'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'buyerName'}
              field={'customer.userCode'}
              title={'CustomerName'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>پارت تحویل</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable addUrl="" disablePageSize />
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                {this.state.showLinkIndividual && (
                  <Link
                    to={'/printBaskets' + this.props.location.search}
                    class="printLink d-inline-block"
                    style={{marginTop: '10px'}}
                    target="_blank"
                  >
                    <span>چاپ فاکتور</span>
                  </Link>
                )}
                {/*{this.state.showLinkIndividual &&*/}
                {/*    <Link to={'/printBasketsA4' + this.props.location.search} class='printLink d-inline-block' style={{marginTop:'10px'}} target='_blank'>*/}
                {/*        <span className='d-inline-block' style={{marginTop: '-10px'}}> فاکتورهای بیشتر از ۸ آیتم A4</span>*/}
                {/*    </Link>*/}
                {/*}*/}
                {this.state.showLinkIndividual && (
                  <Link
                    to={'/a4Print' + this.props.location.search}
                    class="printLink d-inline-block"
                    style={{marginTop: '10px'}}
                    target="_blank"
                  >
                    <span className="d-inline-block" style={{marginTop: '-10px'}}>
                      چاپ فاکتور A4
                    </span>
                  </Link>
                )}
                {/*{this.state.showLinkIndividual &&*/}
                {/*    <Link to={'/printBascketA4Les8Factor' + this.props.location.search} class='printLink d-inline-block' style={{marginTop:'10px'}} target='_blank'>*/}
                {/*        <span className='d-inline-block' style={{marginTop: '-10px'}}> فاکتورهای کمتر از ۸ آیتم A4</span>*/}
                {/*    </Link>*/}
                {/*}*/}
                {this.state.showLinkIndividual && (
                  <Link
                    to={'/printLabel' + this.props.location.search}
                    class="printLink d-inline-block"
                    style={{marginTop: '10px'}}
                    target="_blank"
                  >
                    <span>چاپ لیبیل</span>
                  </Link>
                )}
                {this.state.showLinkIndividual && (
                  <Link
                    to={'/printRoll' + this.props.location.search}
                    class="printLink d-inline-block"
                    style={{marginTop: '10px'}}
                    target="_blank"
                  >
                    <span>چاپ Roll</span>
                  </Link>
                )}
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className={'printButton'}
                  style={{width: '120px'}}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.newExcel}
                >
                  OP Time Export
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue={this.state.defaultValueDate}
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromRegDate}
                  onChangeToDate={this.handleChangeToRegDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={false}
                  fromId="fromReg"
                  toId="toReg"
                />

                <div className="formComponent">
                  <label>شیفت زمانی :</label>
                  <select className="form-control" onChange={this.changeShift.bind(this)} id="planTimeType">
                    <option value="">-------</option>
                    {this.state.timesInterval.map((shift, index) => (
                      <option value={shift.timeIntervalId}>{shift.timeStart + ' تا ' + shift.timeEnd}</option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input
                    type="text"
                    defaultValue={this.state.invoiceId}
                    className="form-control"
                    id="invoiceId"
                    name="invoiceId"
                  />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input
                    type="text"
                    defaultValue={this.state.invoiceNum}
                    className="form-control"
                    id="invoiceNum"
                    name="invoiceNum"
                  />
                </div>

                <div className="formComponent">
                  <label>کد مشتری:</label>
                  <input
                    type="text"
                    defaultValue={this.state.userCode}
                    className="form-control"
                    id="userCode"
                    name="userCode"
                  />
                </div>

                <div className="formComponent">
                  <label>کد ملی مشتری:</label>
                  <input type="text" className="form-control" id="nationalId" name="nationalId" />
                </div>

                <div className="formComponent">
                  <label>موبایل (در فاکتور) : </label>
                  <input type="text" className="form-control" id="mobile" name="mobile" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار (در فاکتور) :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده (در فاکتور) :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>حالت:</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="lastState"
                    name="lastState"
                  >
                    <option value="">-------</option>
                    <option value="-100">کنسل</option>
                    <option value="-75">مرجوعی</option>
                    <option value="-50">بازگشتی</option>
                    <option value="100">تخصیص مجدد</option>
                    <option value="-1">تخصیص داده نشده</option>
                    <option value="1">فعال</option>
                    <option value="15">تحویل ناقص</option>
                    <option value="5">اول فعال</option>
                    <option value="10">شروع شده</option>
                    <option value="18">تسویه شده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت از :</label>
                  <input type="text" className="form-control" id="payableAmountMin" name="payableAmountMin" />
                </div>

                <div className="formComponent">
                  <label>قابل پرداخت تا :</label>
                  <input type="text" className="form-control" id="payableAmountMax" name="payableAmountMax" />
                </div>

                <div className="formComponent">
                  <label>دریافتی نقدی از :</label>
                  <input type="text" className="form-control" id="cashMin" name="cashMin" />
                </div>

                <div className="formComponent">
                  <label>دریافتی نقدی تا :</label>
                  <input type="text" className="form-control" id="cashMax" name="cashMax" />
                </div>

                <div className="formComponent">
                  <label>واحد کالا :</label>
                  <Select
                    value={this.state.multiUnit}
                    onChange={this.handleChangeUnit}
                    options={this.state.unit}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده ها :</label>
                                    <Select
                                        value={this.state.multiProvider}
                                        onChange={this.handleChangeProvider}
                                        options={this.state.providers}
                                        isMulti={true}
                                        isClearable={true}
                                        placeholder=''
                                    /> */}
                </div>
                <div className="formComponent">
                  <label>دارای رسید کاغذی</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="paperInvoice"
                    name="paperInvoice"
                  >
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>
              </div>
              <div>
                {this.state.providers.length ? (
                  <SearchProduct
                    getStocks={this.getStocks}
                    finalStocks={this.finalStocks}
                    providers={this.state.providers}
                  />
                ) : null}
              </div>

              <div className="filterOption">
                {loading ? (
                  <button disabled className="confirmFilter" onClick={this.filter.bind(this)}>
                    جست و جو
                  </button>
                ) : (
                  <button className="confirmFilter" onClick={this.filter.bind(this)}>
                    جست و جو
                  </button>
                )}
              </div>
            </div>

            <DeliveryPackComponent
              deliveryPackData={this.state.baskets}
              aggregation={this.state.aggregation}
              pageNumber={this.state.tablePageNumber}
              pageSize={this.state.tablePageSize}
              getDeliverySort={this.getSort}
            />
            {this.state.baskets.length > 0 && (
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Baskets)
